// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBY2vUILMDeydegV2FjQd6Xn1wsET_ITDM",
    authDomain: "accent-db-48c9b.firebaseapp.com",
    databaseURL: "https://accent-db-48c9b.firebaseio.com",
    projectId: "accent-db-48c9b",
    storageBucket: "accent-db-48c9b.appspot.com",
    messagingSenderId: "339399522200",
    appId: "1:339399522200:web:9f291bd9776c6b47cddded",
    measurementId: "G-Q2ZHGEQ887"
  }
}


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
